import { request } from './client';
import { Deck, CreateDeckPayload } from '../types/deck';

export async function fetchDecks(): Promise<Deck[]> {
  return request<Deck[]>('/decks');
}

export async function createDeck(payload: CreateDeckPayload): Promise<Deck> {
  return request<Deck>('/decks', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
